export default class GeoLocationService {
  geoLocation = null;
  unavailable = false;
  coordTypes = { lat: 'latitude', lon: 'longitude', alt: 'altitude' };
  
  async getPosition(update = false){
    if(this.unavailable || (this.geoLocation && !update)){
      return this.geoLocation;
    }
    return await this._updatePosition();
  }

  getCoordinate(type) {
    const prop = this.coordTypes[type];
    const coords = (this.geoLocation?.coords || {});
    const hasData = Object.keys(this.coordTypes).some(t => !!coords[this.coordTypes[t]]);

    if (!hasData) return null;
    if (prop) return coords[prop];

    const { altitude=null, longitude=null, latitude=null } = coords;
    return JSON.stringify({altitude, longitude, latitude});
  }

  _findPosition() {
    return new Promise((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject)
    );
  }

  async _updatePosition() {
    let error = false;
    if (navigator.geolocation) {
      try { this.geoLocation = await this._findPosition() } 
      catch(err) { error = true }
    } 
    else error = true;

    if (error) {
      this.unavailable = true;
      this.geoLocation = {};
    }

    return this.geoLocation;
  }
}
